"use client";

import { MutableRefObject, useEffect, useState } from "react";

export const useParallax = (target: MutableRefObject<any>, factor = 0.1) => {
  const [parallax, setParallax] = useState(0);

  useEffect(() => {
    let raf: any;

    const scrollHandler = () => {
      const { pageYOffset } = window;

      setParallax(pageYOffset * factor);
    };

    const onScroll = () => {
      raf = window.requestAnimationFrame(scrollHandler);
    };

    if (target.current) {
      window.addEventListener("scroll", onScroll);
      onScroll();
    }

    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(raf);
    };
  }, [target, factor]);

  return parallax;
};
